export default class Line {
    constructor () {
        this.supportState = true
        this.onObject = {}
        this.go()
    }



    go () {
        const dt = this.support()
        if (this.supportState) {
           dt.forEach(key => {
                window.addEventListener(key, resLine => {
                    this.onObject[key].forEach(handler => handler(resLine))
                })
            })
        }
    }

    check () {
        return new Promise((rs, rj) => {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", ""+ window.location.origin +  process.env.BASE_URL + "favicon.ico", true)
            xhr.setRequestHeader("Cache-Control", "no-cache")
            xhr.onreadystatechange = event => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    return rs(xhr)
                }
                console.log(xhr, event)
            }
            xhr.onerror = e => {
                console.log(e, 'err', xhr)
                return rj(e)
            }
            xhr.send(null)
        })
    }

    on (key, handler) {
        if (!this.onObject[key]) this.onObject[key] = []
        this.onObject[key].push(handler)
    }

    support () {
        const res = "onLine" in window.navigator ? ["online", "offline"] : false
        this.supportState = !!res
        return res
    }
}
